import { useState } from "react";
import PopUpPanel from "../PopUpPanel/PopUpPanel";
import FormField from "../forms/FormField/FormField";
import PropTypes from 'prop-types';

import "./SalesforcePopup.scss";

const SalesforcePopup = ({ closePanelFunc, submitFunc, initialValue = 0 }) => {
    const [sfNumber, setSfNumber] = useState(initialValue);
    const [sfNumberError, setSfNumberError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!sfNumber || sfNumber <= 0) {
            setSfNumberError('Please enter a valid Salesforce number');
            return;
        }
        
        submitFunc(sfNumber);
    };

    const handleSkip = (e) => {
        e.preventDefault();
        closePanelFunc();
    };

    return (
        <PopUpPanel closePanelFunc={closePanelFunc} className="salesforce-popup">
            <div className="salesforce-popup-content">
                <h2>Enter Salesforce Number</h2>
                <p>Enter your Salesforce number to automatically populate campaign details from AirTable.</p>
                
                <FormField 
                    id="salesfoce_number_popup" 
                    type="number"
                    label="Salesforce Number" 
                    placeholder="" 
                    setFunc={setSfNumber} 
                    value={sfNumber} 
                    error={sfNumberError} 
                />

                <div className="popup-actions">
                    <button 
                        className="skip-btn standard-button" 
                        onClick={handleSkip}
                    >
                        Skip
                    </button>
                    <button 
                        className="submit-btn standard-button button-active" 
                        onClick={handleSubmit}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </PopUpPanel>
    );
};

SalesforcePopup.propTypes = {
    closePanelFunc: PropTypes.func.isRequired,
    submitFunc: PropTypes.func.isRequired,
    initialValue: PropTypes.number
};

export default SalesforcePopup;
